import { useState } from 'react';

import { Button } from '../../../../common/Atoms/Button';
import { Modal } from '../../../../common/Atoms/Modal';
import { useGetSelectedOrganisation } from '../../../hooks/useGetSelectedOrganisation';
import { useSetParentContactMutation } from '../../../services/api/contactsApi/contacts';
import { ContactSearch, IPickedContact } from '../../Common/ContactSearch';

interface SetParentContactProps {
  selectedContacts: number[];
  open: boolean;
  setOpen: (open: boolean) => void;
}

export function SetParentContact({ selectedContacts, open, setOpen }: SetParentContactProps) {
  const [selectedParent, setSelectedParent] = useState<IPickedContact | undefined>();
  const currentOrg = useGetSelectedOrganisation();
  const [setParentContact, { isLoading }] = useSetParentContactMutation();

  async function handleConfirm() {
    if (!currentOrg?.id || !selectedParent) return;

    // Validation errors are toasted by the RTK middleware; keep the modal open so they can pick again
    const result = await setParentContact({
      organisationId: currentOrg.id,
      contactIds: selectedContacts,
      parentContactId: selectedParent.id,
    });

    if (`error` in result) return;

    setOpen(false);
    setSelectedParent(undefined);
  }

  function handleClose(value: boolean) {
    setOpen(value);
    setSelectedParent(undefined);
  }

  return (
    <Modal
      title={ `Set Parent Contact` }
      open={ open }
      setOpen={ handleClose }
    >
      <div className={ `space-y-4 p-4` }>
        <p className={ `text-sm text-gray-500` }>
          { `Search for a contact to set as the parent of the ${selectedContacts.length} selected contact(s).` }
        </p>

        <ContactSearch
          label={ `Parent Contact` }
          selected={ selectedParent }
          onSelect={ setSelectedParent }
          excludeIds={ selectedContacts }
        />

        <div className={ `flex justify-end space-x-2` }>
          <Button
            color={ `gray` }
            onClick={ () => handleClose(false) }
          >
            { `Cancel` }
          </Button>
          <Button
            disabled={ !selectedParent }
            loading={ isLoading }
            onClick={ handleConfirm }
          >
            { `Set Parent` }
          </Button>
        </div>
      </div>
    </Modal>
  );
}
